import styled from 'styled-components';
import { fontStyle } from '../../styles/mixins';
import {
  FONT_SIZE_4,
  FONT_WEIGHT_BOLD,
  FONT_WEIGHT_NORMAL,
  GRAY_NORMAL_DARK,
  WHITE,
} from '../../styles/variables';

import BrokenIcon from '../../images/broken-link.svg';

export const ConnectionError = styled.div`
  height: auto;
  width: auto;

  p {
    margin-bottom: 0;
    text-align: center;
    ${fontStyle(GRAY_NORMAL_DARK, '24px', FONT_WEIGHT_NORMAL)};
  }

  button {
    width: 194px;
    height: 49px;
    border-radius: 4px;
    display: block;
    margin: 27px auto 0;
    ${fontStyle(WHITE, FONT_SIZE_4, FONT_WEIGHT_BOLD)};
  }
`;

export const BrokenLink = styled.div`
  width: 73px;
  height: 73px;
  background: url(${BrokenIcon}) no-repeat;
  background-size: cover;
  margin: 75px auto 43px;
`;



// WEBPACK FOOTER //
// ./src/components/ErrorHandler/style.js